// src/store/filterModalSlice.ts
import { createSlice } from "@reduxjs/toolkit";

type SnackbarState = {
	open: boolean;
};

const initialState: SnackbarState = {
	open: false,
};

const filterModalSlice = createSlice({
	name: "snackbar",
	initialState,
	reducers: {
		showFilterModal: state => {
			state.open = true;
		},
		hideFilterModal: state => {
			state.open = false;
		},
	},
});

export const { showFilterModal, hideFilterModal } = filterModalSlice.actions;
export default filterModalSlice.reducer;
